import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'ad-hoc-filter-date',
  template: require('./adhoc.filter.date.component.html')
})
export class AdHocFilterDateComponent {
    @Input() filter;

  dateRange = {
    fromDate: '',
    toDate: ''
  };
  datePickerOptionsFrom: any;
  datePickerOptionsTo: any;
  fromDateAlias: string;
  toDateAlias: string;

  constructor() {}

  ngOnInit() {
    this.datePickerOptionsFrom = {
      dateFormat: "YYYY-MM-DD",
      allowFreeText: true,
      callback: (value: any) => {
        this.dateRange.fromDate = value;
        this.setDateRange();
      }
    };

    this.datePickerOptionsTo = {
      dateFormat: "YYYY-MM-DD",
      allowFreeText: true,
      callback: (value: any) => {
        this.dateRange.toDate = value;
        this.setDateRange();
      }
    };

    this.processInputDate();

    this.fromDateAlias = this.filter.alias + 'From';
    this.toDateAlias = this.filter.alias + 'To';

    this.setDateRange();
  }

  ngOnChanges() {
    this.processInputDate();
    this.setDateRange();
  }

  onUpdateFrom(val: any) {
    this.dateRange.fromDate = val;
    this.setDateRange();
  }

  onUpdateTo(val: any) {
    this.dateRange.toDate = val;
    this.setDateRange();
  }

  private processInputDate() {
    const arr_values = this.filter.value.split('|-|');
    if (arr_values.length > 1) {
      this.dateRange.fromDate = arr_values[0];
      this.dateRange.toDate = arr_values[1];
    } else {
      this.dateRange.fromDate = this.dateRange.toDate = arr_values[0];
    }
  }

  private setDateRange() {
    this.filter.value = _.get(this, 'dateRange.fromDate', '') + '|-|' + _.get(this, 'dateRange.toDate', '');
  }
}
